import React from "react";
import { arrayOf, bool, func, number, shape, string } from "prop-types";

import { MY_ACTIVITY_TITLE } from "../constants";
import { ItemText, MenuListItem } from "../MultiLevelMenu";
import FoldersForm from "./FoldersForm";

const MyActivityAndFoldersMenu = props => (
  <>
    {props.is_lists ? (
      <MenuListItem isFullSize>
        <ItemText isBig isWithArrow onClick={props.onClick}>
          {MY_ACTIVITY_TITLE}
        </ItemText>
      </MenuListItem>
    ) : null}
    {!props.is_lists && props.folders?.length > 1 ? (
      <MenuListItem isFolder isFullSize>
        <FoldersForm
          current_folder={props.current_folder}
          folders={props.folders}
          form_authenticity_token={props.form_authenticity_token}
        />
      </MenuListItem>
    ) : null}
  </>
);

MyActivityAndFoldersMenu.propTypes = {
  form_authenticity_token: string,
  is_lists: bool,
  onClick: func,
  current_folder: shape({
    id: number
  }),
  folders: arrayOf(
    shape({
      folder: shape({
        id: number,
        name: string
      })
    })
  )
};

MyActivityAndFoldersMenu.defaultProps = {
  onClick: () => ({}),
  is_lists: false,
  form_authenticity_token: "",
  current_folder: undefined,
  folders: []
};

export default MyActivityAndFoldersMenu;
